import { OrderFieldVisibility } from '@euler/model';
import { ReactNode, memo } from 'react';
import { shouldDisplayField } from './util';

function OrderSummaryInfoFieldUnmemo<T>({
  value,
  visibility,
  defaultVisible,
  valid,
  children,
}: {
  value: T;
  valid?: (value: T) => boolean;
  visibility?: OrderFieldVisibility;
  defaultVisible?: boolean;
  children?: ReactNode;
}) {
  const isVisible = shouldDisplayField({
    value,
    visibility,
    defaultVisible,
    valid,
  });

  if (!isVisible) {
    return null;
  }

  return <>{children}</>;
}

export const OrderSummaryInfoField = memo(
  OrderSummaryInfoFieldUnmemo,
) as typeof OrderSummaryInfoFieldUnmemo;
